<template>
  <b-form inline>
    <b-form-group class="mr-2">
      <field
        v-if="showCompanyFilter"
        :model="filters"
        :field="{
          ajax: true,
          attribute: 'company_id',
          component: 'app-relation-field',
          placeholder: $t('company.select_company'),
          preloadValue: true,
          source: {
            url: 'companies',
            params: {
              context: 'options',
            },
          },
        }"
        layout="inline"
        :label="$t('drivers.company')"
        class="mr-2 mb-0"
      />
    </b-form-group>
    <field
      :model="filters"
      :field="{
        attribute: 'date',
        component: 'date-range-field',
        options: {
          autoClose: true,
          formatted: 'll',
          onlyDate: true,
          outputFormat: 'YYYY-MM-DD',
          noShortcuts: true,
          maxDate,
          minDate,
        },
      }"
      layout="inline"
    />
    <field
      :model="filters"
      :field="{
        attribute: 'show_unassigned',
        component: 'checkbox-field',
        label: $t('drivers.new_layout_assignment_unassigned'),
      }"
      layout="inline"
      class="mr-2"
    />
  </b-form>
</template>

<script>
import { ADMINISTER } from '../constants/permissions'

export default {
  name: 'DriversScheduleFilters',

  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      filters: {
        show_unassigned: true,
        company_id: this.$settings?.default_company_id || null,
        date: {
          gte: this.$moment().format('YYYY-MM-DD'),
          lte: this.$moment().add(4, 'd').format('YYYY-MM-DD'),
        },
      },
    }
  },

  computed: {
    maxDate() {
      if (this.filters.date.gte && !this.filters.date.lte) {
        return this.$moment(this.filters.date.gte)
          .add(4, 'd')
          .format('YYYY-MM-DD')
      }
      return ''
    },

    minDate() {
      if (this.filters.date.gte && !this.filters.date.lte) {
        return this.$moment(this.filters.date.gte)
          .subtract(4, 'd')
          .format('YYYY-MM-DD')
      }
      return ''
    },

    showCompanyFilter() {
      return this.$allows(ADMINISTER)
    },
  },

  watch: {
    filters: {
      deep: true,
      handler(filters) {
        if (filters.date.gte && filters.date.lte) {
          this.emitChange()
        }
      },
    },
  },

  mounted() {
    this.filters = { ...this.filters, ...this.value }
    this.emitChange()
  },

  methods: {
    emitChange() {
      this.$emit('input', this.filters)
    },
  },
}
</script>
